<ng-container *ngIf="utils.isPhone; else jobDetailContent">
    <ion-header class="dp-modal-header">
        <ion-toolbar class="top-toolbar">
            <ion-buttons slot="start">
                <ion-button (click)="onDismiss()">
                    <ion-icon name="close" slot="icon-only"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-title>{{ job.name }} - {{ 'projects.jobs.details.title' | translate }}</ion-title>
            <ion-buttons slot="end">
                <ng-container *ngTemplateOutlet="jobLockBtn"></ng-container>
            </ion-buttons>
        </ion-toolbar>
        <ion-toolbar>
            <ion-segment
                (ionChange)="onChangeMobileView($event)"
                [value]="currentMobileView"
                class="job-details-mobile-navigation"
                mode="ios"
            >
                <ion-segment-button value="job-data" [ngClass]="job.jobStatus?.data ? 'color-success' : 'color-danger'">
                    <fa-icon icon="th-list" size="lg"></fa-icon>
                </ion-segment-button>
                <ion-segment-button
                    value="job-photos"
                    [ngClass]="job.jobStatus?.photos ? 'color-success' : 'color-danger'"
                    *ngIf="!hidePhotoSegment"
                >
                    <fa-icon icon="camera" size="lg"></fa-icon>
                </ion-segment-button>
                <ion-segment-button
                    value="job-building-plan"
                    [ngClass]="job.jobStatus?.map ? 'color-success' : 'color-danger'"
                    *ngIf="subView || (!hidePlanSegment && !asDialog)"
                >
                    <fa-icon icon="map-marker" size="lg"></fa-icon>
                </ion-segment-button>
                <ion-segment-button
                    value="job-code"
                    [ngClass]="job.jobStatus?.code ? 'color-success' : 'color-danger'"
                    *ngIf="!hideCodeSegment"
                >
                    <fa-icon [icon]="['fal', 'qrcode']" size="lg"></fa-icon>
                </ion-segment-button>
            </ion-segment>
        </ion-toolbar>
    </ion-header>
    <ion-content [scrollY]="!scanEnabled">
        <ng-container *ngTemplateOutlet="fabButtons"></ng-container>
        <ng-container *ngTemplateOutlet="jobDetailContent"></ng-container>
    </ion-content>
</ng-container>

<ng-template #jobDetailContent>
    <div class="component-wrap" *ngIf="jobFormGroup != null && project != null">
        <!--
            this template is either used as direct content of the component or inside
			the the above mobile template for working in a modal
        -->
        <ion-header *ngIf="!utils.isPhone">
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-button fill="clear" *ngIf="asDialog" (click)="closeDialog()">
                        <fa-icon icon="arrow-from-right"></fa-icon>
                    </ion-button>

                    <ion-button fill="clear" *ngIf="!asDialog" (click)="utils.toggleSplitPaneMenu('job-split-pane')">
                        <!-- <fa-icon [icon]="['fal', 'arrow-alt-from-right']" slot="icon-only" size="lg"></fa-icon> -->
                        <ion-icon name="menu-outline" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-label slot="start"
                    >{{ this.jobFormGroup.get('jobNumber').value + ' ' + this.jobFormGroup.get('name').value }}
                </ion-label>
                <div slot="start">
                    <!-- <app-project-reminders *ngIf="!isViewer && changesAllowed" [item]="job"></app-project-reminders> -->
                    <ion-chip
                        color="primary"
                        outline="true"
                        (click)="onOpenDesktopBuildingPlanDialog()"
                        *ngIf="buildingPlanList?.length > 0 && !hidePlanSegment"
                        [disabled]="!subView && asDialog"
                    >
                        <fa-icon icon="map-marker"></fa-icon>
                        <ion-label
                            >{{
                                jobBuildingPlan?.name != '' && job?.marker && job?.marker.length > 0
                                    ? jobBuildingPlan?.name
                                    : ('projects.jobs.details.marker-btn' | translate)
                            }}
                        </ion-label>
                    </ion-chip>

                    <ng-container *ngTemplateOutlet="nextDueDateChip"></ng-container>

                    <ion-chip
                        *ngIf="canGenerateCustomQRCode"
                        color="primary"
                        outline="true"
                        [disabled]="currentlyGeneratingQrCode"
                        (click)="generateQrCode()"
                    >
                        <fa-icon icon="qrcode"></fa-icon>
                        <ion-label>{{ 'projects.jobs.details.generate-qrcode-btn' | translate }}</ion-label>
                    </ion-chip>

                    <ng-container *ngTemplateOutlet="jobLinkChip"></ng-container>

                    <ion-chip
                        *ngIf="settingsSrv.currentCompanyFeatures.externalJobId"
                        [formGroup]="jobFormGroup"
                        color="primary"
                        outline="true"
                    >
                        <fa-icon icon="hashtag"></fa-icon>
                        {{ 'projects.jobs.details.ext-id' | translate }}:
                        <ion-input
                            class="external-job-id-input dp-ml-s"
                            type="text"
                            formControlName="externalJobId"
                            [placeholder]="'projects.jobs.details.input' | translate"
                            [readonly]="!changesAllowed || job.locked || isViewer"
                        ></ion-input>
                    </ion-chip>
                    <ng-container *ngTemplateOutlet="jobLockChip"></ng-container>
                </div>
            </ion-toolbar>
        </ion-header>

        <ng-template #nextDueDateChip>
            @let dueDateRelativeTime = job.nextDueDateTimestamp ? utils.getRelativeTimeForDueDate(job.nextDueDateTimestamp) : null;
            @let dueDateTooltipContent =
                job.nextDueDateTimestamp
                    ? settingsSrv.getUserRights().canSeeCalendar !== 'none'
                        ? ('projects.due-date.show-details' | translate)
                        : ('projects.jobs.list.due-date' | translate)
                    : null;
            <ion-chip
                *ngIf="(job.dueDates?.length > 0 && canOpenDueDates) || job.nextDueDateTimestamp"
                class="next-due-date-chip"
                [color]="dueDateRelativeTime?.color ?? 'primary'"
                outline="true"
                dpTooltip
                [tooltipContent]="dueDateTooltipContent"
                [tooltipPosition]="'bottom'"
                (click)="openDueDateModal()"
            >
                <fa-icon icon="clock"></fa-icon>
                <ion-label *ngIf="job.nextDueDateTimestamp">{{ job.nextDueDateTimestamp | date: 'dd.MM.yyyy' }} </ion-label>
                <ion-label *ngIf="!job.nextDueDateTimestamp">{{ 'projects.due-date.btn-lbl' | translate }}</ion-label>
            </ion-chip>
        </ng-template>

        <ng-container *ngIf="!utils.isPhone">
            <ng-container *ngTemplateOutlet="fabButtons"></ng-container>
        </ng-container>

        <div
            class="page-wrap"
            [class.as-dialog]="asDialog && !utils.isPhone"
            [class.is-phone]="utils.isPhone"
            [ngClass]="job.locked ? 'job-locked' : ''"
            #contentScrollContainer
        >
            <div class="page-content">
                <div class="edit-job-wrap" *ngIf="jobFormGroup && serviceGroup">
                    <form [formGroup]="jobFormGroup">
                        <!-- START: DESKTOP VIEW -->
                        <div class="job-details-desktop" *ngIf="!utils.mobileViewActive">
                            <div>
                                <div class="reorder-info" *ngIf="shiftPressed || altPressed">
                                    <fa-icon icon="info-circle" size="sm"></fa-icon>
                                    <span *ngIf="shiftPressed">
                                        <strong class="info-heading">{{ 'projects.jobs.details.reorder-active' | translate }}: </strong
                                        >{{ 'projects.jobs.details.reorder-job-extensions' | translate }}
                                    </span>
                                    <span *ngIf="altPressed">
                                        <strong class="info-heading">{{ 'projects.jobs.details.reorder-active' | translate }}: </strong
                                        >{{ 'projects.jobs.details.reorder-job-photos' | translate }}
                                    </span>
                                </div>
                            </div>
                            <app-job-form-data
                                [jobForm]="jobFormGroup"
                                [possibleWorkers]="possibleWorkers"
                                [serviceGroup]="serviceGroup"
                                [changesAllowed]="changesAllowed && !isViewer && !job.locked"
                                [asDialog]="asDialog"
                            ></app-job-form-data>
                            <!-- START JOB EXTENSIONS / ARTICLES - DESKTOP VIEW -->
                            <div class="job-extensions-wrap" cdkDropListGroup>
                                <ion-grid *ngIf="!jobExtensionsLoading">
                                    <!-- job additional fields -->
                                    <ng-container *ngIf="serviceGroup?.settings?.positionAdditionalFields === 'above'">
                                        <ng-container *ngTemplateOutlet="jobAdditionalFields"></ng-container>
                                    </ng-container>

                                    <ion-row>
                                        <ion-col [size]="12 - serviceGroupPhotoCategoriesCount * 2">
                                            <!-- display job extensions or old article data --->
                                            <ng-container
                                                *ngIf="
                                                    currentJobExtensionFormGroups.length > 0 || getJobArticlesFormArray().length > 0;
                                                    else chooseArticleInline
                                                "
                                            >
                                                <!-- old (deprecated) job articles - only used to display old data -->
                                                <ng-container *ngIf="getJobArticlesFormArray().length > 0" formArrayName="articles">
                                                    <ion-row
                                                        class="job-article-wrap"
                                                        *ngFor="let oldArticle of getJobArticlesFormArray().controls; index as articleIndex"
                                                    >
                                                        <ion-col>
                                                            <ion-card class="job-article-card ion-no-margin" [formGroupName]="articleIndex">
                                                                <ion-card-header class="ion-no-padding">
                                                                    <ion-toolbar color="transparent">
                                                                        <ion-title mode="md" class="ion-no-padding">
                                                                            <ion-card-title
                                                                                >{{ oldArticle.get('name').value }}
                                                                            </ion-card-title>
                                                                        </ion-title>
                                                                        <ion-buttons slot="end" *ngIf="changesAllowed && !job.locked">
                                                                            <ion-button
                                                                                color="danger"
                                                                                fill="clear"
                                                                                size="small"
                                                                                (click)="onDeleteOldJobArticle(articleIndex)"
                                                                            >
                                                                                <fa-icon icon="trash" slot="icon-only"></fa-icon>
                                                                            </ion-button>
                                                                        </ion-buttons>
                                                                    </ion-toolbar>
                                                                </ion-card-header>
                                                                <ion-card-content class="dp-pt-0">
                                                                    <app-job-article
                                                                        [articleFormGroup]="oldArticle"
                                                                        [changesAllowed]="
                                                                            changesAllowed &&
                                                                            allowedArticleChangesMap.get(oldArticle.value._id) &&
                                                                            !job.locked
                                                                        "
                                                                        [asDialog]="asDialog"
                                                                    ></app-job-article>
                                                                </ion-card-content>
                                                            </ion-card>
                                                        </ion-col>
                                                    </ion-row>
                                                </ng-container>

                                                <!-- display job extensions -->
                                                <ion-accordion-group
                                                    multiple="true"
                                                    #jobExtensionAccordion
                                                    expand="inset"
                                                    mode="md"
                                                    class="job-extension-accordion-group"
                                                    [value]="currentExpandedJobExtensions"
                                                    (ionChange)="jobExtAccordionChanged($event, self)"
                                                    #self
                                                >
                                                    <ion-reorder-group
                                                        [disabled]="!reorderExtensionsEnabled"
                                                        (ionItemReorder)="onReorderExtensions($event)"
                                                    >
                                                        <ng-container
                                                            *ngFor="
                                                                let exFormGroup of this.currentJobExtensionFormGroups;
                                                                index as extensionIndex
                                                            "
                                                        >
                                                            <div
                                                                class="reorder-wrapper"
                                                                [class.reorder-item-wrap]="reorderExtensionsEnabled"
                                                            >
                                                                <app-job-extension
                                                                    [jobExtensionFormGroup]="exFormGroup"
                                                                    [job]="job"
                                                                    [serviceGroupPhotoCategoriesCount]="serviceGroupPhotoCategoriesCount"
                                                                    [possibleWorkers]="possibleWorkers"
                                                                    [deletionAllowed]="
                                                                        (settingsSrv.currentUserRights.canManageProjects ||
                                                                            (changesAllowed &&
                                                                                allowedArticleChangesMap.get(
                                                                                    exFormGroup.value.article._id
                                                                                ))) &&
                                                                        (!isViewer || exFormGroup.value.createdBy === currentUserID)
                                                                    "
                                                                    [changesAllowed]="
                                                                        !job.locked &&
                                                                        !reorderExtensionsEnabled &&
                                                                        (settingsSrv.currentUserRights.canManageProjects ||
                                                                            (changesAllowed &&
                                                                                allowedArticleChangesMap.get(
                                                                                    exFormGroup.value.article._id
                                                                                )))
                                                                    "
                                                                    [managementChangesAllowed]="
                                                                        settingsSrv.currentUserRights.canManageProjects
                                                                    "
                                                                    [enableDuplication]="
                                                                        (settingsSrv.currentUserRights.canManageProjects ||
                                                                            (changesAllowed &&
                                                                                allowedArticleChangesMap.get(
                                                                                    exFormGroup.value.article._id
                                                                                ))) &&
                                                                        !isViewer
                                                                    "
                                                                    [extensionExpanded]="
                                                                        jobExtensionAccordion?.value?.includes(exFormGroup.value._id)
                                                                    "
                                                                    [asDialog]="asDialog"
                                                                    [reorderActive]="reorderExtensionsEnabled"
                                                                    (duplicateJobExtensionRequested)="onDuplicateJobExtension(exFormGroup)"
                                                                    (deleteJobExtensionRequested)="onDeleteJobExtension(extensionIndex)"
                                                                    (refreshJobExtensionFieldsRequested)="
                                                                        onRefreshJobExtensionFields(exFormGroup, exJobExtensionCompRef)
                                                                    "
                                                                    (jobExtensionFormGroupChanged)="onJobExtensionChanged(exFormGroup)"
                                                                    (jobSaveRequested)="onSaveJob(false)"
                                                                    (articleHelpModalClicked)="onOpenArticleHelpModal($event)"
                                                                    (lockRequested)="onLockRequested($event, exFormGroup)"
                                                                    (removedJobLinkId)="onJobLinkRemovedFromField($event)"
                                                                    (addedJobLinkId)="onJobLinkAddedToField($event)"
                                                                    #exJobExtensionCompRef
                                                                ></app-job-extension>
                                                            </div>
                                                        </ng-container>
                                                    </ion-reorder-group>
                                                </ion-accordion-group>

                                                <!-- action to add a new job extension / article -->
                                                <ion-row *ngIf="changesAllowed && availableArticles.length > 0">
                                                    <ion-col>
                                                        <div class="job-article-add">
                                                            <ion-button
                                                                expand="block"
                                                                (click)="onAddJobExtension()"
                                                                class="job-add-new-article"
                                                                [disabled]="job.locked"
                                                            >
                                                                <fa-icon icon="plus" slot="start"></fa-icon>
                                                                {{ 'projects.jobs.details.add-article-btn' | translate }}
                                                            </ion-button>
                                                        </div>
                                                    </ion-col>
                                                </ion-row>
                                            </ng-container>

                                            <!-- job additional fields -->
                                            <ng-container *ngIf="serviceGroup?.settings?.positionAdditionalFields === 'below'">
                                                <ng-container *ngTemplateOutlet="jobAdditionalFields"></ng-container>
                                            </ng-container>
                                        </ion-col>

                                        <!-- display job photos of service group (not article bound) if the service group has photo settings -->
                                        <ion-col *ngIf="serviceGroupPhotoCategoriesCount > 0" [size]="serviceGroupPhotoCategoriesCount * 2">
                                            <app-job-photos
                                                [job]="job"
                                                [changesAllowed]="changesAllowed && !isViewer && !job.locked"
                                                (changed)="onPhotosChanged()"
                                            ></app-job-photos>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </div>
                            <!-- END JOB EXTENSIONS -->

                            <div class="job-additional-info-wrap">
                                <ion-grid>
                                    <!-- WEATHER -->
                                    <ng-container
                                        *ngIf="
                                            serviceGroup.settings.dataRecording.weatherRecording !== possibleDataRecordingSettings.Disabled
                                        "
                                    >
                                        <ion-row>
                                            <ion-col>
                                                <app-job-weather
                                                    [job]="job"
                                                    [changesAllowed]="changesAllowed && !isViewer && !job.locked"
                                                ></app-job-weather>
                                            </ion-col>
                                        </ion-row>
                                    </ng-container>

                                    <!-- SIGNATURES -->
                                    <ng-container
                                        *ngIf="
                                            serviceGroup.settings.dataRecording.signatureRecording !==
                                            possibleDataRecordingSettings.Disabled
                                        "
                                    >
                                        <ion-row>
                                            <ion-col>
                                                <app-job-signature
                                                    [job]="job"
                                                    [project]="project"
                                                    [changesAllowed]="changesAllowed && !job.locked"
                                                    (lockJob)="onLockJobsAfterSigning()"
                                                ></app-job-signature>
                                            </ion-col>
                                        </ion-row>
                                    </ng-container>

                                    <!-- JOB LINKINGS -->
                                    <ion-row
                                        *ngIf="
                                            job.linkedJobIds.length > 1 ||
                                            (projectServiceGroupCount > 1 && settingsSrv.getCompanySettings().enableJobLinkings)
                                        "
                                    >
                                        <ion-col [class.list-margin-bottom]="utils.isPhone" class="ion-no-padding job-linking-card-wrap">
                                            <ion-card class="job-linkings-list">
                                                <ion-card-header>
                                                    <ion-card-title
                                                        >{{ 'projects.jobs.details.job-linking-title' | translate }}
                                                    </ion-card-title>
                                                </ion-card-header>
                                                <ion-card-content>
                                                    <div *ngIf="job.linkedJobIds.length == 0" class="ion-text-center">
                                                        {{ 'projects.jobs.details.no-job-linkings' | translate }}
                                                    </div>
                                                    <app-job-linkings
                                                        [currentJobId]="job?._id"
                                                        [linkedJobIds]="job.linkedJobIds"
                                                        [changesAllowed]="changesAllowed && !job.locked"
                                                        (removeJobLinkRequested)="onRemoveJobLink($event.removedJobLinkIndex)"
                                                        #jobLinkingComp
                                                    ></app-job-linkings>
                                                    <div class="link-actions-wrap ion-text-center" *ngIf="changesAllowed && !job.locked">
                                                        <app-new-job-linking
                                                            [currentJobId]="job?._id"
                                                            (jobLinkConfirmed)="onSaveJobLinkAdded($event)"
                                                        ></app-new-job-linking>
                                                    </div>
                                                </ion-card-content>
                                            </ion-card>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </div>
                            <div style="height: 20px">
                                <!-- spacer to prevent ng-select dropdowns from being cut of on bottom of screen -->
                            </div>
                        </div>

                        <!-- START: DESKTOP BUILDING PLAN DIALOG -->
                        <ion-modal
                            class="modal-l"
                            [class.stack-modal]="subView"
                            [isOpen]="buildingPlanModalVisible"
                            (ionModalDidDismiss)="buildingPlanModalVisible = false"
                        >
                            <ng-template>
                                <ion-content>
                                    @if (jobBuildingPlan && jobBuildingPlan.planType === 'bim') {
                                        <ng-container *ngIf="jobBuildingPlan && !utils.isPhone">
                                            <app-project-bim-building-plans
                                                (destructiveClicked)="onRemovePlanMarking()"
                                                (successClicked)="onSaveMarker($event)"
                                                (planChanged)="onSelectBuildingPlan($event)"
                                                [projectView]="false"
                                                [viewOnly]="!changesAllowed || isViewer || job.locked"
                                                [job]="job"
                                                [asDialog]="true"
                                                [buildingPlan]="jobBuildingPlan"
                                                [buildingPlanList]="buildingPlanList"
                                                (markerChanged)="onMarkerChanged($event)"
                                            ></app-project-bim-building-plans>
                                        </ng-container>
                                    } @else {
                                        <ng-container>
                                            <app-building-plan-details
                                                *ngIf="showDialogPlanView"
                                                [buildingPlan]="jobBuildingPlan"
                                                [job]="job"
                                                [buildingPlanList]="buildingPlanList"
                                                [serviceGroup]="serviceGroup"
                                                [viewOnly]="!changesAllowed || isViewer || job.locked"
                                                [asDialog]="true"
                                                [blockSaveActions]="blockSave"
                                                (successClicked)="onSaveMarker($event)"
                                                (destructiveClicked)="onRemovePlanMarking()"
                                                (planChanged)="onSelectBuildingPlan($event)"
                                                (markerChanged)="onMarkerChanged($event)"
                                            ></app-building-plan-details>
                                        </ng-container>
                                    }
                                </ion-content>
                            </ng-template>
                        </ion-modal>
                        <!-- END: DESKTOP BUILDING PLAN DIALOG -->

                        <!-- START: DUE DATE DIALOG -->
                        <ion-modal class="stack-modal" [isOpen]="dueDateModalVisible" (ionModalDidDismiss)="onDueDateModalDismiss()">
                            <ng-template>
                                <ion-header>
                                    <ion-toolbar color="none">
                                        <ion-title>{{ 'projects.due-date.title' | translate }}</ion-title>
                                        <ion-buttons slot="end">
                                            <ion-button fill="clear" shape="round" color="dark" (click)="dueDateModalVisible = false">
                                                <ion-icon slot="icon-only" name="close"></ion-icon>
                                            </ion-button>
                                        </ion-buttons>
                                    </ion-toolbar>
                                </ion-header>

                                <ion-content class="ion-padding due-date-modal">
                                    @let dueDates = dueDatesToDisplay;
                                    <ion-list-header class="section-header">
                                        <ion-label
                                            >{{ 'projects.due-date.future-title' | translate }} ({{ dueDates.length || 0 }})
                                        </ion-label>
                                    </ion-list-header>

                                    <ion-list lines="none" class="due-dates-list">
                                        @for (dueDate of dueDates; track dueDate; let i = $index) {
                                            @let relativeTime = utils.getRelativeTimeForDueDate(dueDate.startTimestamp);
                                            <ion-item [class.is-next]="i === 0" class="due-item {{ relativeTime.color }}">
                                                @if (changesAllowed && settingsSrv.getUserRights().canManageCalendar) {
                                                    <ion-checkbox
                                                        slot="start"
                                                        labelPlacement="end"
                                                        [disabled]="job.locked"
                                                        [checked]="isDueDateDone(dueDate.doneAt)"
                                                        (ionChange)="onToggleDueDate(dueDate)"
                                                    >
                                                        <ng-container *ngTemplateOutlet="checkBoxContent"></ng-container>
                                                    </ion-checkbox>
                                                } @else {
                                                    <ng-container *ngTemplateOutlet="checkBoxContent"></ng-container>
                                                }

                                                <ng-template #checkBoxContent>
                                                    <ion-label>
                                                        <div class="due-date-t">
                                                            <div class="due-date-dot" [style.background-color]="dueDate.color"></div>
                                                            <h2>
                                                                {{ dueDate.startTimestamp | date: 'EEEE, dd. MMMM yyyy' }}
                                                                @if (!dueDate.fullDay) {
                                                                    {{
                                                                        'projects.due-date.date-range'
                                                                            | translate
                                                                                : {
                                                                                      start: dueDate.startTimestamp | date: 'HH:mm',
                                                                                      end: dueDate.endTimestamp | date: 'HH:mm',
                                                                                  }
                                                                    }}
                                                                }
                                                            </h2>
                                                        </div>
                                                        <p>{{ dueDate.relatedFieldName ? dueDate.relatedFieldName : dueDate.name }}</p>
                                                        <div class="relative-time">{{ relativeTime.label }}</div>
                                                    </ion-label>
                                                    <ion-badge slot="end" [color]="relativeTime.color" *ngIf="i === 0">
                                                        {{ 'projects.due-date.next' | translate }}
                                                    </ion-badge>
                                                </ng-template>
                                            </ion-item>
                                        }
                                    </ion-list>

                                    @let doneDueDates = doneDueDatesToDisplay;
                                    <ion-list-header class="section-header">
                                        <ion-label
                                            >{{ 'projects.due-date.past-title' | translate }}({{ doneDueDates.length || 0 }}
                                            )
                                        </ion-label>
                                    </ion-list-header>

                                    <ion-list lines="none" class="due-dates-list">
                                        <ion-item *ngFor="let dueDate of doneDueDates" class="due-item is-done">
                                            @if (changesAllowed && settingsSrv.getUserRights().canManageCalendar) {
                                                <ion-checkbox
                                                    slot="start"
                                                    labelPlacement="end"
                                                    [disabled]="job.locked"
                                                    [checked]="isDueDateDone(dueDate.doneAt)"
                                                    (ionChange)="onToggleDueDate(dueDate)"
                                                >
                                                    <ng-container *ngTemplateOutlet="checkBoxContent"></ng-container>
                                                </ion-checkbox>
                                            } @else {
                                                <ng-container *ngTemplateOutlet="checkBoxContent"></ng-container>
                                            }

                                            <ng-template #checkBoxContent>
                                                <ion-label>
                                                    <div class="due-date-t">
                                                        <div class="due-date-dot" [style.background-color]="dueDate.color"></div>
                                                        <h2>
                                                            {{ dueDate.startTimestamp | date: 'EEEE, dd. MMMM yyyy' }}
                                                            @if (!dueDate.fullDay) {
                                                                {{
                                                                    'projects.due-date.date-range'
                                                                        | translate
                                                                            : {
                                                                                  start: dueDate.startTimestamp | date: 'HH:mm',
                                                                                  end: dueDate.endTimestamp | date: 'HH:mm',
                                                                              }
                                                                }}
                                                            }
                                                        </h2>
                                                    </div>
                                                    <p>{{ dueDate.relatedFieldName ? dueDate.relatedFieldName : dueDate.name }}</p>
                                                </ion-label>
                                            </ng-template>
                                        </ion-item>
                                    </ion-list>
                                </ion-content>
                            </ng-template>
                        </ion-modal>
                        <!-- END: DUE DATE DIALOG -->
                        <!-- END: DESKTOP VIEW -->

                        <!-- START: MOBILE VIEW -->
                        <div class="job-details-mobile" *ngIf="utils.mobileViewActive" cdkDropListGroup>
                            <ng-container *ngIf="currentMobileView === 'job-data'">
                                <ion-row *ngIf="utils.isPhone">
                                    <ion-col size="12">
                                        <ng-container *ngTemplateOutlet="nextDueDateChip"></ng-container>
                                        <ng-container *ngTemplateOutlet="jobLinkChip"></ng-container>
                                    </ion-col>
                                </ion-row>

                                <app-job-form-data
                                    [jobForm]="jobFormGroup"
                                    [possibleWorkers]="possibleWorkers"
                                    [serviceGroup]="serviceGroup"
                                    [changesAllowed]="changesAllowed && !isViewer && !job.locked"
                                ></app-job-form-data>

                                <!-- START JOB EXTENSIONS / ARTICLES - MOBILE VIEW -->
                                <div class="job-extensions-wrap">
                                    <ion-grid *ngIf="!jobExtensionsLoading">
                                        <!-- job additional fields -->
                                        <ng-container *ngIf="serviceGroup?.settings?.positionAdditionalFields === 'above'">
                                            <ng-container *ngTemplateOutlet="jobAdditionalFields"></ng-container>
                                        </ng-container>

                                        <ion-row>
                                            <ion-col size="12">
                                                <!-- display job extensions or old article data --->
                                                <ng-container
                                                    *ngIf="
                                                        currentJobExtensionFormGroups.length > 0 || getJobArticlesFormArray().length > 0;
                                                        else chooseArticleInline
                                                    "
                                                >
                                                    <!-- old (deprecated) job articles - only used to display old data -->
                                                    <ng-container *ngIf="getJobArticlesFormArray().length > 0" formArrayName="articles">
                                                        <ion-row
                                                            class="job-article-wrap"
                                                            *ngFor="
                                                                let oldArticle of getJobArticlesFormArray().controls;
                                                                index as articleIndex
                                                            "
                                                        >
                                                            <ion-col>
                                                                <ion-card
                                                                    class="job-article-card ion-no-margin"
                                                                    [formGroupName]="articleIndex"
                                                                >
                                                                    <ion-card-header class="ion-no-padding">
                                                                        <ion-toolbar color="none">
                                                                            <ion-title mode="md" class="ion-no-padding">
                                                                                <ion-card-title
                                                                                    >{{ oldArticle.get('name').value }}
                                                                                </ion-card-title>
                                                                            </ion-title>
                                                                            <ion-buttons slot="end" *ngIf="changesAllowed && !job.locked">
                                                                                <ion-button
                                                                                    color="danger"
                                                                                    fill="clear"
                                                                                    size="small"
                                                                                    (click)="onDeleteOldJobArticle(articleIndex)"
                                                                                >
                                                                                    <fa-icon icon="trash" slot="icon-only"></fa-icon>
                                                                                </ion-button>
                                                                            </ion-buttons>
                                                                        </ion-toolbar>
                                                                    </ion-card-header>
                                                                    <ion-card-content class="dp-pt-0">
                                                                        <app-job-article
                                                                            [articleFormGroup]="oldArticle"
                                                                            [changesAllowed]="
                                                                                changesAllowed &&
                                                                                allowedArticleChangesMap.get(oldArticle.value._id) &&
                                                                                !job.locked
                                                                            "
                                                                            [asDialog]="asDialog"
                                                                        ></app-job-article>
                                                                    </ion-card-content>
                                                                </ion-card>
                                                            </ion-col>
                                                        </ion-row>
                                                    </ng-container>

                                                    <!-- display job extensions -->
                                                    <ion-accordion-group
                                                        multiple="true"
                                                        #jobExtensionAccordion
                                                        expand="inset"
                                                        mode="md"
                                                        class="job-extension-accordion-group"
                                                        [value]="currentExpandedJobExtensions"
                                                        (ionChange)="jobExtAccordionChanged($event, self)"
                                                        #self
                                                    >
                                                        <ion-reorder-group
                                                            [disabled]="!reorderExtensionsEnabled"
                                                            (ionItemReorder)="onReorderExtensions($event)"
                                                        >
                                                            <ng-container
                                                                *ngFor="
                                                                    let exFormGroup of this.currentJobExtensionFormGroups;
                                                                    index as extensionIndex
                                                                "
                                                            >
                                                                <div
                                                                    class="reorder-wrapper"
                                                                    [class.reorder-item-wrap]="reorderExtensionsEnabled"
                                                                >
                                                                    <app-job-extension
                                                                        [jobExtensionFormGroup]="exFormGroup"
                                                                        [job]="job"
                                                                        [serviceGroupPhotoCategoriesCount]="
                                                                            serviceGroupPhotoCategoriesCount
                                                                        "
                                                                        [possibleWorkers]="possibleWorkers"
                                                                        [deletionAllowed]="
                                                                            (settingsSrv.currentUserRights.canManageProjects ||
                                                                                (changesAllowed &&
                                                                                    allowedArticleChangesMap.get(
                                                                                        exFormGroup.value.article._id
                                                                                    ))) &&
                                                                            (!isViewer || exFormGroup.value.createdBy === currentUserID)
                                                                        "
                                                                        [changesAllowed]="
                                                                            !job.locked &&
                                                                            !reorderExtensionsEnabled &&
                                                                            (settingsSrv.currentUserRights.canManageProjects ||
                                                                                (changesAllowed &&
                                                                                    allowedArticleChangesMap.get(
                                                                                        exFormGroup.value.article._id
                                                                                    )))
                                                                        "
                                                                        [managementChangesAllowed]="
                                                                            settingsSrv.currentUserRights.canManageProjects
                                                                        "
                                                                        [enableDuplication]="
                                                                            (settingsSrv.currentUserRights.canManageProjects ||
                                                                                (changesAllowed &&
                                                                                    allowedArticleChangesMap.get(
                                                                                        exFormGroup.value.article._id
                                                                                    ))) &&
                                                                            !isViewer
                                                                        "
                                                                        [extensionExpanded]="
                                                                            jobExtensionAccordion?.value?.includes(exFormGroup.value._id)
                                                                        "
                                                                        [asDialog]="asDialog"
                                                                        [reorderActive]="reorderExtensionsEnabled"
                                                                        (duplicateJobExtensionRequested)="
                                                                            onDuplicateJobExtension(exFormGroup)
                                                                        "
                                                                        (deleteJobExtensionRequested)="onDeleteJobExtension(extensionIndex)"
                                                                        (refreshJobExtensionFieldsRequested)="
                                                                            onRefreshJobExtensionFields(exFormGroup, exJobExtensionCompRef)
                                                                        "
                                                                        (jobExtensionFormGroupChanged)="onJobExtensionChanged(exFormGroup)"
                                                                        (jobSaveRequested)="onSaveJob(false)"
                                                                        (articleHelpModalClicked)="onOpenArticleHelpModal($event)"
                                                                        (lockRequested)="onLockRequested($event, exFormGroup)"
                                                                        (removedJobLinkId)="onJobLinkRemovedFromField($event)"
                                                                        (addedJobLinkId)="onJobLinkAddedToField($event)"
                                                                        #exJobExtensionCompRef
                                                                    ></app-job-extension>
                                                                </div>
                                                            </ng-container>
                                                        </ion-reorder-group>
                                                    </ion-accordion-group>

                                                    <!-- action to add a new job extension / article -->
                                                    <ion-row *ngIf="changesAllowed && availableArticles.length > 0 && !job.locked">
                                                        <ion-col>
                                                            <div class="job-article-add">
                                                                <ion-button
                                                                    expand="block"
                                                                    (click)="onAddJobExtension()"
                                                                    class="job-add-new-article"
                                                                >
                                                                    <fa-icon icon="plus" slot="start"></fa-icon>
                                                                    {{ 'projects.jobs.details.add-article-btn' | translate }}
                                                                </ion-button>
                                                            </div>
                                                        </ion-col>
                                                    </ion-row>
                                                </ng-container>
                                                <!-- job additional fields -->
                                                <ng-container *ngIf="serviceGroup?.settings?.positionAdditionalFields === 'below'">
                                                    <ng-container *ngTemplateOutlet="jobAdditionalFields"></ng-container>
                                                </ng-container>
                                            </ion-col>
                                        </ion-row>
                                    </ion-grid>
                                </div>
                                <!-- END JOB EXTENSIONS / ARTICLES - MOBILE VIEW -->

                                <ng-container
                                    *ngIf="serviceGroup.settings.dataRecording.weatherRecording !== possibleDataRecordingSettings.Disabled"
                                >
                                    <app-job-weather
                                        [job]="job"
                                        [changesAllowed]="changesAllowed && !isViewer && !job.locked"
                                    ></app-job-weather>
                                </ng-container>

                                <ng-container *ngIf="!utils.isPhone && utils.mobileViewActive">
                                    <!-- show photos on smaller window when not in modal -->
                                    <ion-row class="job-photo-container-wrap">
                                        <app-job-photos
                                            [job]="job"
                                            [changesAllowed]="changesAllowed && !isViewer && !job.locked"
                                            (changed)="onPhotosChanged()"
                                        ></app-job-photos>
                                    </ion-row>
                                </ng-container>

                                <ng-container
                                    *ngIf="
                                        serviceGroup.settings.dataRecording.signatureRecording !== possibleDataRecordingSettings.Disabled
                                    "
                                >
                                    <app-job-signature
                                        [job]="job"
                                        [project]="project"
                                        [changesAllowed]="changesAllowed && !job.locked"
                                        (lockJob)="onLockJobsAfterSigning()"
                                    ></app-job-signature>
                                </ng-container>

                                <ng-container
                                    *ngIf="
                                        job.linkedJobIds.length > 1 ||
                                        (projectServiceGroupCount > 1 && settingsSrv.getCompanySettings().enableJobLinkings)
                                    "
                                >
                                    <ion-row>
                                        <ion-col [class.list-margin-bottom]="utils.isPhone" class="ion-no-padding job-linking-card-wrap">
                                            <ion-card class="job-linkings-list">
                                                <ion-card-header>
                                                    <ion-card-title
                                                        >{{ 'projects.jobs.details.job-linking-title' | translate }}
                                                    </ion-card-title>
                                                </ion-card-header>
                                                <ion-card-content>
                                                    <div *ngIf="job.linkedJobIds.length == 0" class="ion-text-center">
                                                        {{ 'projects.jobs.details.no-job-linkings' | translate }}
                                                    </div>
                                                    <app-job-linkings
                                                        [currentJobId]="job?._id"
                                                        [linkedJobIds]="job.linkedJobIds"
                                                        [changesAllowed]="changesAllowed && !job.locked"
                                                        (removeJobLinkRequested)="onRemoveJobLink($event.removedJobLinkIndex)"
                                                        #jobLinkingComp
                                                    ></app-job-linkings>
                                                    <div class="link-actions-wrap ion-text-center" *ngIf="changesAllowed && !job.locked">
                                                        <app-new-job-linking
                                                            [currentJobId]="job?._id"
                                                            (jobLinkConfirmed)="onSaveJobLinkAdded($event)"
                                                        ></app-new-job-linking>
                                                    </div>
                                                </ion-card-content>
                                            </ion-card>
                                        </ion-col>
                                    </ion-row>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="currentMobileView === 'job-photos'">
                                <div cdkDropListGroup>
                                    <!-- this view displays photos on phone in modal with segments -->
                                    <!-- photos of existing job extensions -->
                                    <ng-container *ngFor="let exFormGroup of this.currentJobExtensionFormGroups; index as extensionIndex">
                                        <app-job-extension
                                            viewMode="photos-only"
                                            [jobExtensionFormGroup]="exFormGroup"
                                            [job]="job"
                                            [serviceGroupPhotoCategoriesCount]="serviceGroupPhotoCategoriesCount"
                                            [possibleWorkers]="possibleWorkers"
                                            [deletionAllowed]="
                                                (settingsSrv.currentUserRights.canManageProjects ||
                                                    (changesAllowed && allowedArticleChangesMap.get(exFormGroup.value.article._id))) &&
                                                (!isViewer || exFormGroup.value.createdBy === currentUserID)
                                            "
                                            [changesAllowed]="
                                                !job.locked &&
                                                !reorderExtensionsEnabled &&
                                                (settingsSrv.currentUserRights.canManageProjects ||
                                                    (changesAllowed && allowedArticleChangesMap.get(exFormGroup.value.article._id)))
                                            "
                                            [managementChangesAllowed]="settingsSrv.currentUserRights.canManageProjects"
                                            [enableDuplication]="
                                                (settingsSrv.currentUserRights.canManageProjects ||
                                                    (changesAllowed && allowedArticleChangesMap.get(exFormGroup.value.article._id))) &&
                                                !isViewer
                                            "
                                            [extensionExpanded]="true"
                                            [asDialog]="asDialog"
                                            (duplicateJobExtensionRequested)="onDuplicateJobExtension(exFormGroup)"
                                            (deleteJobExtensionRequested)="onDeleteJobExtension(extensionIndex)"
                                            (jobExtensionFormGroupChanged)="onJobExtensionChanged(exFormGroup)"
                                            (jobSaveRequested)="onSaveJob(false)"
                                            (lockRequested)="onLockRequested($event, exFormGroup)"
                                            (removedJobLinkId)="onJobLinkRemovedFromField($event)"
                                            (addedJobLinkId)="onJobLinkAddedToField($event)"
                                            #exJobExtensionCompRef
                                        ></app-job-extension>
                                    </ng-container>

                                    <!-- job photos, based on service group, not bound to an article -->
                                    <app-job-photos
                                        [job]="job"
                                        [changesAllowed]="changesAllowed && !isViewer && !job.locked"
                                        (changed)="onPhotosChanged()"
                                    ></app-job-photos>
                                </div>

                                <!-- spacer to keep images above mobile fabs -->
                                <div class="list-padding-bottom"></div>
                            </ng-container>

                            <ng-container *ngIf="currentMobileView === 'job-building-plan'">
                                @if (jobBuildingPlan && jobBuildingPlan.planType === 'bim') {
                                    <ng-container *ngIf="subView || !asDialog; else showMarkerNotAllowedInDialog">
                                        <app-project-bim-building-plans
                                            (destructiveClicked)="onRemovePlanMarking()"
                                            (successClicked)="onSaveJob()"
                                            (planChanged)="onSelectBuildingPlan($event)"
                                            [projectView]="false"
                                            [subView]="subView"
                                            [viewOnly]="!changesAllowed || isViewer || job.locked"
                                            [job]="job"
                                            [buildingPlan]="jobBuildingPlan"
                                            [buildingPlanList]="buildingPlanList"
                                        ></app-project-bim-building-plans>
                                    </ng-container>
                                } @else {
                                    <ng-container>
                                        <ng-container *ngIf="subView || !asDialog; else showMarkerNotAllowedInDialog">
                                            <app-building-plan-details
                                                [buildingPlan]="jobBuildingPlan"
                                                [job]="job"
                                                [buildingPlanList]="buildingPlanList"
                                                [serviceGroup]="serviceGroup"
                                                [viewOnly]="!changesAllowed || isViewer || job.locked"
                                                [blockSaveActions]="blockSave"
                                                [subView]="subView"
                                                (successClicked)="onSaveJob()"
                                                (destructiveClicked)="onDeleteJob()"
                                                (planChanged)="onSelectBuildingPlan($event)"
                                                (markerChanged)="onMarkerChanged($event)"
                                            ></app-building-plan-details>
                                        </ng-container>
                                    </ng-container>
                                }
                                <ng-template #showMarkerNotAllowedInDialog>
                                    <div class="ion-align-items-center ion-padding dp-center-wrap">
                                        <p class="ion-text-center">
                                            {{ 'projects.jobs.details.markers-not-allowed-info' | translate }}
                                        </p>
                                    </div>
                                </ng-template>
                            </ng-container>

                            <ng-container *ngIf="currentMobileView === 'job-code'">
                                <app-code-scanner
                                    [(isEnabled)]="scanEnabled"
                                    containerType="modal"
                                    [searchIcon]="'check'"
                                    (onScanResult)="onScanResult($event)"
                                ></app-code-scanner>
                                <ion-row *ngIf="!scanEnabled">
                                    <ion-col>
                                        <ion-card>
                                            <ion-card-content>
                                                <div class="mobile-code-icon ion-text-center">
                                                    <fa-icon icon="qrcode"></fa-icon>
                                                </div>
                                                <ion-input
                                                    fill="outline"
                                                    mode="md"
                                                    [label]="'projects.jobs.details.code-label' | translate"
                                                    labelPlacement="floating"
                                                    [placeholder]="'projects.jobs.details.code-placeholder' | translate"
                                                    type="text"
                                                    dpCodeValidator
                                                    formControlName="code"
                                                    class="ion-text-center bg-light dp-mt-l"
                                                    (ionChange)="onCodeChanged($event)"
                                                    [readonly]="!changesAllowed || isViewer || job.locked"
                                                ></ion-input>
                                                <ion-button
                                                    class="dp-mt-l"
                                                    (click)="startScan()"
                                                    expand="block"
                                                    *ngIf="changesAllowed && !isViewer && !job.locked"
                                                >
                                                    <fa-icon [icon]="['fal', 'qrcode']" slot="start"></fa-icon>
                                                    <ion-label>{{ 'projects.jobs.details.start-scan-btn' | translate }}</ion-label>
                                                </ion-button>
                                            </ion-card-content>
                                        </ion-card>

                                        <ion-card *ngIf="canGenerateCustomQRCode">
                                            <ion-card-content>
                                                <ion-button
                                                    expand="block"
                                                    [disabled]="currentlyGeneratingQrCode"
                                                    (click)="generateQrCode()"
                                                >
                                                    <fa-icon [icon]="['fal', 'qrcode']" slot="start"></fa-icon>
                                                    <ion-label>{{ 'projects.jobs.details.generate-qrcode-btn' | translate }}</ion-label>
                                                </ion-button>
                                            </ion-card-content>
                                        </ion-card>

                                        <ion-card *ngIf="settingsSrv.currentCompanyFeatures.externalJobId">
                                            <ion-card-content>
                                                <ion-row>
                                                    <ion-col size="12">
                                                        <ion-input
                                                            fill="outline"
                                                            mode="md"
                                                            [label]="'projects.jobs.details.ext-id' | translate"
                                                            labelPlacement="floating"
                                                            class="ion-text-center bg-light"
                                                            [placeholder]="'projects.jobs.details.ext-id' | translate"
                                                            type="text"
                                                            formControlName="externalJobId"
                                                            [disabled]="!changesAllowed || isViewer || job.locked"
                                                        ></ion-input>
                                                    </ion-col>
                                                </ion-row>
                                            </ion-card-content>
                                        </ion-card>
                                    </ion-col>
                                </ion-row>
                            </ng-container>
                        </div>
                        <!-- END: MOBILE VIEW -->
                    </form>

                    <!-- template to display the choose-article-grid inline if there are no job extensions yet -->
                    <ng-template #chooseArticleInline>
                        <ion-row *ngIf="availableArticles.length > 0 && !job.locked">
                            <ion-col>
                                <div class="no-job-extensions">
                                    <!-- display article grid inline -->
                                    <ion-card class="ion-no-margin">
                                        <ion-card-header>
                                            <ion-card-title>
                                                <h2 class="ion-text-center">
                                                    {{ 'projects.jobs.details.choose-article-title' | translate }}
                                                </h2>
                                            </ion-card-title>
                                        </ion-card-header>
                                        <ion-card-content>
                                            <ng-container *ngTemplateOutlet="chooseArticleGrid"></ng-container>
                                        </ion-card-content>
                                    </ion-card>
                                </div>
                            </ion-col>
                        </ion-row>
                    </ng-template>

                    <!-- template to display job additional fields (above or below job articles) -->
                    <ng-template #jobAdditionalFields>
                        <ion-row class="job-additional-fields-wrap">
                            <ion-col>
                                <ion-card class="job-additional-fields-card">
                                    <ion-card-header class="ion-no-padding" style="padding-inline-start: 7px">
                                        <ion-toolbar color="none" style="--min-height: auto; padding-left: 0">
                                            <ion-title mode="md" class="ion-no-padding">
                                                <ion-card-title class="ion-text-wrap"
                                                    >{{
                                                        serviceGroup?.settings?.headingAdditionalFields != null &&
                                                        serviceGroup.settings.headingAdditionalFields.trim() !== ''
                                                            ? serviceGroup.settings.headingAdditionalFields
                                                            : ('projects.jobs.details.additional-fields' | translate)
                                                    }}
                                                </ion-card-title>
                                            </ion-title>
                                            <ion-buttons
                                                slot="end"
                                                *ngIf="changesAllowed && !job.locked && getJobFieldsFormArray().length > 0"
                                            >
                                                <ion-button
                                                    fill="clear"
                                                    size="small"
                                                    color="primary"
                                                    dpTooltip
                                                    tooltipTheme="light"
                                                    tooltipPosition="left"
                                                    [tooltipTrigger]="'click mouseenter focus'"
                                                    tooltipInteractive="true"
                                                    hideTooltipAfterInteraction="true"
                                                    [tooltipContent]="jobAdditionalFieldsActionsDropdown"
                                                >
                                                    <fa-icon icon="ellipsis-h" slot="icon-only"></fa-icon>
                                                </ion-button>
                                            </ion-buttons>
                                        </ion-toolbar>
                                    </ion-card-header>
                                    <ion-card-content class="dp-p-0">
                                        <ion-row>
                                            <ion-col>
                                                <ng-container *ngIf="getJobFieldsFormArray().length > 0; else emptyJobAdditionalFields">
                                                    <app-job-additional-fields
                                                        [projectId]="project._id"
                                                        [jobId]="job._id"
                                                        [jobFormGroup]="jobFormGroup"
                                                        [changesAllowed]="changesAllowed && !isViewer && !job.locked"
                                                        [asDialog]="asDialog"
                                                        #jobAdditionalFieldsComponent
                                                    ></app-job-additional-fields>
                                                </ng-container>
                                            </ion-col>
                                        </ion-row>
                                    </ion-card-content>
                                </ion-card>
                            </ion-col>
                        </ion-row>
                    </ng-template>

                    <!-- dialog that will be displayed if the user wants to add additional articles -->
                    <ion-modal
                        class="modal-height-auto"
                        [ngClass]="{ 'stack-modal': asDialog }"
                        [isOpen]="chooseArticleModalVisible"
                        (ionModalDidDismiss)="chooseArticleModalVisible = false"
                    >
                        <ng-template>
                            <ion-header>
                                <ion-toolbar color="none">
                                    <ion-title>{{ 'projects.jobs.details.select-article-title' | translate }}</ion-title>
                                    <ion-buttons slot="end">
                                        <ion-button fill="clear" shape="round" color="primary" (click)="chooseArticleModalVisible = false">
                                            <fa-icon slot="icon-only" icon="times"></fa-icon>
                                        </ion-button>
                                    </ion-buttons>
                                </ion-toolbar>
                            </ion-header>
                            <div class="inner-content">
                                <ng-container *ngTemplateOutlet="chooseArticleGrid"></ng-container>
                            </div>
                        </ng-template>
                    </ion-modal>

                    <!-- the choose article grid which is displayed inline or in a dialog, if the user wants to add an additional article -->
                    <ng-template #chooseArticleGrid>
                        <ion-toolbar color="transparent">
                            <ion-searchbar
                                color="light"
                                [cancelButtonText]="'shared.cancel' | translate"
                                [enterkeyhint]="'projects.jobs.details.filter' | translate"
                                [placeholder]="'projects.jobs.details.search-article' | translate"
                                debounce="400"
                                (ionInput)="filterArticles($event.detail.value)"
                                (ionCancel)="resetFilterArticles()"
                                (ionClear)="resetFilterArticles()"
                                [(ngModel)]="articleSearchBarCurrentValue"
                            ></ion-searchbar>
                        </ion-toolbar>
                        <div class="choose-article-wrap choose-article-grid">
                            <ion-grid class="article-selection-grid">
                                <ion-row>
                                    <ng-container *ngFor="let article of filteredAvailableArticles; let i = index">
                                        <ion-col class="article-item-col" [size]="filteredAvailableArticles.length == 1 ? 12 : 6">
                                            <ion-button fill="solid" expand="block" color="light">
                                                <div class="article-selection-item" (click)="onArticleChosen(article)">
                                                    <div class="article-selection-icon">
                                                        <ng-container
                                                            *ngIf="
                                                                article.icon != null && article.icon.iconName != null;
                                                                else articleAcronym
                                                            "
                                                        >
                                                            <app-field-icon-view
                                                                class="choose-article-grid-icon"
                                                                style="height: 100%"
                                                                [icon]="article.icon"
                                                                faIconSize="3x"
                                                            ></app-field-icon-view>
                                                        </ng-container>
                                                        <ng-template #articleAcronym>
                                                            <ion-chip color="primary" class="acronym"
                                                                >{{ utils.getAcronym(article.name) }}
                                                            </ion-chip>
                                                        </ng-template>
                                                    </div>
                                                    <ion-label class="article-selection-name" lang="de">
                                                        {{ article.name }}
                                                    </ion-label>
                                                </div>
                                            </ion-button>
                                        </ion-col>
                                    </ng-container>
                                    <ng-container *ngIf="availableArticles.length > 0 && filteredAvailableArticles.length === 0">
                                        <ion-col>
                                            <div class="no-search-result ion-text-center dp-mt-m">
                                                {{ 'projects.jobs.details.no-search-results' | translate }}
                                            </div>
                                        </ion-col>
                                    </ng-container>
                                </ion-row>
                            </ion-grid>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>

        <!-- attachment component which is triggered automatically if camera shall open automatically in photo-documentation-only mode -->
        <ng-container *ngIf="settingsSrv.photoDocumentationOnly || settingsSrv.vendingOnly">
            <div class="photo-documentation-only-hidden-photo-select">
                <app-attachment-select
                    [allowedFileTypes]="['image']"
                    [folder]="project._id + '/jobs/' + job._id"
                    (compInitialized)="autoOpenCamera()"
                    (fileSelected)="onPhotoDocumentationOnlyFirstPhotoAdded($event)"
                    [buttonText]="'projects.jobs.details.upload-image-btn' | translate"
                    #photoDocumentationAutoAttachmentSelect
                ></app-attachment-select>
            </div>
        </ng-container>
    </div>
</ng-template>

<!-- Depending on user iterface we need to position our fabs differently -->
<ng-template #fabButtons>
    @if (!subView || currentMobileView !== 'job-building-plan') {
        <ion-grid
            slot="fixed"
            class="dp-g-fab h-end fixed"
            [ngClass]="utils.isPhone ? 'bottom' : 'top dp-edge'"
            *ngIf="!scanEnabled && (currentMobileView !== 'job-building-plan' || asDialog)"
        >
            <ion-row>
                <ion-col
                    *ngIf="
                        changesAllowed &&
                        settingsSrv.currentUserRights.canManageProjects &&
                        !asDialog &&
                        !job.locked &&
                        !reorderExtensionsEnabled
                    "
                >
                    <ion-button class="dp-g-fab-btn" shape="round" color="danger" size="small" (click)="onDeleteJob()">
                        <fa-icon icon="trash" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
                <ion-col *ngIf="asDialog">
                    <ion-button color="warning" size="small" shape="round" class="dp-g-fab-btn" (click)="closeDialog()">
                        <fa-icon icon="times" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
                @if (currentMobileView === 'job-data') {
                    <ion-col *ngIf="this.serviceGroup.settings.dataRecording.extensionOrderFixed">
                        <ion-button
                            class="dp-g-fab-btn"
                            color="light"
                            size="small"
                            shape="round"
                            (click)="changeJobExtSortingMode(this.currentJobExtensionSortingMode === 'desc' ? 'asc' : 'desc')"
                        >
                            <fa-icon
                                [icon]="[
                                    'fal',
                                    this.currentJobExtensionSortingMode === 'asc' ? 'sort-numeric-down' : 'sort-numeric-down-alt',
                                ]"
                                slot="icon-only"
                            ></fa-icon>
                        </ion-button>
                    </ion-col>
                    <ion-col
                        *ngIf="
                            currentJobExtensionFormGroups.length > 1 &&
                            !this.serviceGroup.settings.dataRecording.extensionOrderFixed &&
                            !job.locked &&
                            !reorderExtensionsEnabled
                        "
                    >
                        <ion-button
                            class="dp-g-fab-btn"
                            shape="round"
                            size="small"
                            [color]="reorderExtensionsEnabled ? 'warning' : 'light'"
                            (click)="onToggleReorder()"
                        >
                            <fa-icon icon="sort" slot="icon-only"></fa-icon>
                        </ion-button>
                    </ion-col>
                }
                <ng-container *ngIf="changesAllowed">
                    <ion-col>
                        <ion-button
                            class="dp-g-fab-btn"
                            *ngIf="!utils.isPhone && !asDialog && !isViewer && !reorderExtensionsEnabled"
                            color="primary"
                            size="small"
                            shape="round"
                            dpTooltip
                            [tooltipContent]="'projects.jobs.details.duplicate-job-btn' | translate"
                            tooltipTrigger="mouseenter focus"
                            tooltipPosition="bottom"
                            (click)="onDuplicateJob()"
                        >
                            <fa-icon icon="clone" slot="icon-only"></fa-icon>
                        </ion-button>
                    </ion-col>
                    @if (currentMobileView === 'job-data') {
                        <ion-col *ngIf="availableArticles.length > 0 && !job.locked && !reorderExtensionsEnabled">
                            <ion-button
                                class="dp-g-fab-btn add-article-fab"
                                color="primary"
                                size="small"
                                shape="round"
                                dpTooltip
                                [tooltipContent]="'projects.jobs.details.add-article-btn' | translate"
                                tooltipPosition="bottom"
                                (click)="currentMobileView === 'job-data' ? onAddJobExtension() : null"
                            >
                                <fa-icon icon="plus" slot="icon-only"></fa-icon>
                            </ion-button>
                        </ion-col>
                    }
                    <ion-col *ngIf="!job.locked">
                        <ion-button
                            class="job-save-action dp-g-fab-btn"
                            color="success"
                            shape="round"
                            [disabled]="!jobFormGroup?.valid || blockSave"
                            (click)="onSaveJob(utils.mobileViewActive || asDialog)"
                        >
                            <fa-icon icon="check" slot="icon-only"></fa-icon>
                        </ion-button>
                    </ion-col>
                </ng-container>
            </ion-row>
        </ion-grid>
    }
</ng-template>

<ng-template #jobAdditionalFieldsActionsDropdown>
    <div class="dropdown-links">
        <ion-list class="bg-white">
            <ion-item class="no-padding bg-white" lines="none" button (click)="onRefreshJobAdditionalFields()">
                <fa-icon icon="arrows-rotate" class="color-black dp-mr-s"></fa-icon>
                <ion-label>{{ 'projects.jobs.details.refresh-fields-btn' | translate }}</ion-label>
            </ion-item>
        </ion-list>
    </div>
</ng-template>

<ng-template #emptyJobAdditionalFields>
    <div class="ion-text-center">
        {{ 'projects.jobs.details.no-additional-fields' | translate }}
        <div class="dp-mt-s" *ngIf="changesAllowed && !job.locked">
            <ion-button size="small" (click)="onRefreshJobAdditionalFields()">
                <fa-icon icon="arrows-rotate" class="dp-mr-s"></fa-icon>
                {{ 'projects.jobs.details.refresh-fields-btn' | translate }}
            </ion-button>
        </div>
    </div>
</ng-template>

<ng-template #jobLockChip>
    <ion-chip class="job-lock-icon" [color]="job.locked ? 'danger' : 'dark'" outline="true" (click)="onManuallyLockJob()">
        <ng-container *ngTemplateOutlet="jobLockItemContent"></ng-container>
    </ion-chip>
</ng-template>

<ng-template #jobLockBtn>
    <ion-button class="job-lock-btn" [color]="job.locked ? 'danger' : 'light'" fill="solid" (click)="onManuallyLockJob()">
        <ng-container *ngTemplateOutlet="jobLockItemContent"></ng-container>
    </ion-button>
</ng-template>

<ng-template #jobLinkChip>
    <ion-chip
        *ngIf="!asDialog && job?.referringSourceJobId"
        color="primary"
        outline="true"
        dpTooltip
        [tooltipContent]="'projects.jobs.details.source-job-link-info' | translate"
        [tooltipPosition]="'bottom'"
        (click)="onViewSourceJob()"
    >
        <fa-icon icon="link"></fa-icon>
    </ion-chip>
</ng-template>

<ng-template #jobLockItemContent>
    @if (!job.locked) {
        <fa-icon
            dpTooltip
            tooltipTrigger="click mouseenter focus"
            [tooltipContent]="
                !settingsSrv.currentUserRights.canLockJobs || !changesAllowed
                    ? ('projects.jobs.details.lock-not-allowed' | translate)
                    : undefined
            "
            icon="unlock"
        ></fa-icon>
    } @else {
        <fa-icon
            dpTooltip
            tooltipTrigger="click mouseenter focus"
            [tooltipContent]="
                !settingsSrv.currentUserRights.canUnlockJobs || !changesAllowed
                    ? ('projects.jobs.details.unlock-not-allowed' | translate)
                    : undefined
            "
            icon="lock"
        ></fa-icon>
    }
</ng-template>

<!-- START: DIALOG TO FOR ARTICLE HELP -->
<ion-modal
    [ngClass]="{ 'stack-modal': asDialog }"
    #articleHelpModal
    [isOpen]="articleHelpModalVisible"
    (didDismiss)="articleHelpModalVisible = false"
>
    <ng-template>
        <ion-header>
            <ion-toolbar color="none">
                <ion-title>{{ 'projects.jobs.details.article-help-title' | translate }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button fill="clear" color="primary" (click)="articleHelpModalVisible = false">
                        <fa-icon icon="times" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-no-padding">
            <ion-grid>
                <ion-row>
                    <ng-container *ngIf="articleHelpEntries.length > 0; else noHelpEntries">
                        <ng-container *ngFor="let articleHelp of articleHelpEntries">
                            <ion-col [size]="articleHelpEntries.length === 1 ? '12' : articleHelpEntries.length % 3 === 0 ? '4' : '6'">
                                <app-attachment-view [attachment]="articleHelp" [showCreationTime]="false"></app-attachment-view>
                            </ion-col>
                        </ng-container>
                    </ng-container>
                    <ng-template #noHelpEntries>
                        <ion-col size="12">
                            <div class="dp-mt-m">
                                <app-info-bar>
                                    {{ 'projects.jobs.details.no-article-help' | translate }}
                                </app-info-bar>
                            </div>
                        </ion-col>
                    </ng-template>
                </ion-row>
            </ion-grid>
        </ion-content>
        <ion-footer>
            <ion-toolbar color="none">
                <ion-buttons slot="end">
                    <ion-button fill="clear" color="primary" (click)="articleHelpModalVisible = false"
                        >{{ 'shared.close' | translate }}
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-footer>
    </ng-template>
</ion-modal>

<ion-modal class="source-job-modal" backdropDismiss="false" [isOpen]="sourceJobModalVisible" (didDismiss)="sourceJobModalVisible = false">
    <ng-template>
        <ion-content class="ion-no-padding">
            <ng-container *ngIf="sourceJobModalJobData != null">
                <app-job-details
                    [job]="sourceJobModalJobData"
                    [project]="sourceJobModalProjectData"
                    [serviceGroup]="sourceJobModalServiceGroupData"
                    [asDialog]="true"
                    (jobWasSaved)="onSourceJobWasSaved($event)"
                ></app-job-details>
            </ng-container>
        </ion-content>
    </ng-template>
</ion-modal>
